import React, { useEffect, useState } from "react";
import Lights from "./Lights";
import Timer from "./Timer";
import LoadingChart from "./LoadingChart";
import NextLoad from "./NextLoad";
import OrderTable from "./OrderTable";
import PositionChange from "./PositionChange";
import "./DisplayIndex.scss";
import { useMeet } from "util/useMeet";
import { usePlatform } from "util/usePlatform";
import { useCurrentLifter } from "util/useCurrentLifter";
import { useCurrentAttempt } from "util/useCurrentAttempt";
import { useKnownLiftingOrder } from "util/useKnownLiftingOrder";
import { useCompleteLiftingOrder } from "util/useCompleteLiftingOrder";
import { useFedConfig } from "util/useFedConfig";
import LifterName from "./LifterName";
import AttemptInfo from "./AttemptInfo";
import TeamName from "./TeamName";
import DivisionInfo from "./DivisionInfo";
import RecordInfo from "./RecordInfo";
import GearIcon from "icons/GearIcon";
import Drawer from "components/drawer/Drawer";
import Checkbox from "components/checkbox/Checkbox";
import classNames from "classnames";
import { DisplaySettingsContext } from "./DisplaySettingsProvider";

const SettingsDrawer = ({
  editMode,
  setEditMode,
}: {
  editMode: boolean;
  setEditMode: (mode: boolean) => void;
}) => {
  return (
    <Drawer
      trigger={
        <>
          <GearIcon />
        </>
      }
    >
      <div className="display-settings-modal-content">
        <Checkbox
          label="Edit Mode"
          value={editMode}
          onCheck={(v) => setEditMode(v)}
        />
      </div>
    </Drawer>
  );
};

const DisplayIndex = () => {
  const [editMode, setEditMode] = useState(false);
  const meet = useMeet();
  const platform = usePlatform();
  const currentLifter = useCurrentLifter();
  const currentAttempt = useCurrentAttempt();
  const knownLiftingOrder = useKnownLiftingOrder();
  const completeLiftingOrder = useCompleteLiftingOrder();
  const federationConfig = useFedConfig();

  useEffect(() => {
    if (meet.displayDefaultURL && !window.location.search) {
      window.location.search = meet.displayDefaultURL;
    }
  }, [meet.displayDefaultURL]);

  useEffect(() => {
    let backgroundStyle = "";

    if (meet.displayBackgroundImageUrl) {
      backgroundStyle = meet.displayBackgroundImageUrl
        ? `background: url(${meet.displayBackgroundImageUrl}) no-repeat fixed; background-size: cover;`
        : "";
    }

    document.body.setAttribute("style", backgroundStyle);

    return () => document.body.setAttribute("style", "");
  }, [meet.displayBackgroundImageUrl]);

  if (!platform || !meet) {
    return null;
  }

  return (
    <DisplaySettingsContext.Provider value={{ editMode }}>
      <div className={classNames("display-index2")}>
        <div className="display-settings-button">
          <SettingsDrawer editMode={editMode} setEditMode={setEditMode} />
        </div>
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          <OrderTable
            meet={meet}
            platform={platform}
            completeLiftingOrder={completeLiftingOrder}
            id="o"
            federationConfig={federationConfig}
          />
          <LifterName currentLifter={currentLifter} id="b" />
          <AttemptInfo meet={meet} currentAttempt={currentAttempt} id="a" />
          <TeamName meet={meet} currentLifter={currentLifter} id="t" />
          <DivisionInfo meet={meet} currentLifter={currentLifter} id="d" />
          <RecordInfo currentAttempt={currentAttempt} id="r" />
          <Timer platform={platform} id="time" />
          <LoadingChart
            meet={meet}
            currentLifter={currentLifter}
            currentAttempt={currentAttempt}
            platform={platform}
            id="c"
          />
          <NextLoad
            meet={meet}
            currentAttempt={currentAttempt}
            liftingOrder={knownLiftingOrder}
            platform={platform}
            id="n"
          />
          <PositionChange
            meet={meet}
            currentAttempt={currentAttempt}
            currentLifter={currentLifter}
            id="p"
          />
          <Lights meet={meet} platformId={platform._id} id="l" />
        </div>
      </div>
    </DisplaySettingsContext.Provider>
  );
};

export default DisplayIndex;
